import React, { useEffect, useState } from 'react';
import { Breadcrumb, Form, Input } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import UpdateCurrencies from './modals/updateCurrencies';
import { ToastContainer } from 'react-toastify';
import { getCurrencies } from '../../../../services/currencies/currenciesApi';


const Currencies = () => {
    const [isOpen, setIsOpen] = useState(false);

    const [currencie, setCurrencie] = useState(null);
    const [consoleCurrencies, setConsoleCurrencies] = useState([]);
    const [pcCurrencies, setPCCurrencies] = useState([]);

    const fetchCurrencies = async () => {
        const response = await getCurrencies();
        const currencySettings = response.data.currency_settings;

        // Separate currencies by type
        setConsoleCurrencies(currencySettings.find(currency => currency.type === 'console'));
        setPCCurrencies(currencySettings.find(currency => currency.type === 'pc'));
    }
    useEffect(() => {
        fetchCurrencies();
    }, []);

    const onUpdate = async () => {
        fetchCurrencies();
    }

    const handleUpdate = (currencie) => {
        setCurrencie(currencie);
        setIsOpen(true);
    }


    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 className='col-lg-11'>
                    <div className="mb-2">
                        <i className="bx bx-tag me-2" style={{ color: "var(--primary-color3) !important" }} />
                        <h3 style={{ color: "var(--primary-color3) !important" }}>Currencies</h3>
                    </div>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <HomeOutlined />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item style={{ color: "var(--primary-color3) !important" }}>Currencies</Breadcrumb.Item>
                    </Breadcrumb>
                </h4>

            </div>

            <h4 className='col-lg-11 mt-4 pt-4' style={{ color: 'var(--primary-color3)' }}>Console Currencies</h4>
            <div className='row'>
                <div className="col-lg-6 mb-3">
                    <label style={{ color: 'var(--primary-color3)' }} htmlFor="console-coins">Coins</label>
                    <div className="input-group">
                        <input style={{ backgroundColor: 'var(--primary-color10) !important' }} disabled type="text" id="console-coins" name="console-coins" required maxLength="255" placeholder="Coins" value={consoleCurrencies?.coins / 1000} className='form-control' />
                        <div className="input-group-append">
                            <span className="input-group-text">K</span>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 mb-3">
                    <label style={{ color: 'var(--primary-color3)' }} htmlFor="console-amount">Amount</label>
                    <div className="input-group">
                        <input style={{ backgroundColor: 'var(--primary-color10) !important' }} disabled type="number" id="console-amount" name="console-amount" required placeholder="Amount" value={consoleCurrencies?.amount} className='form-control' />
                        <div className="input-group-append">
                            <span className="input-group-text">USD</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-12 d-flex justify-content-end'>
                    <Button type='primary' onClick={() => handleUpdate(consoleCurrencies)} >
                        Update
                    </Button>
                </div>
            </div>

            <h4 className='col-lg-11' style={{ color: 'var(--primary-color3)' }}>PC Currencies</h4>
            <div className='row'>
                <div className="col-lg-6 mb-3">
                    <label style={{ color: 'var(--primary-color3)' }} htmlFor="pc-coins">Coins</label>
                    <div className="input-group">
                        <input style={{ backgroundColor: 'var(--primary-color10) !important' }} disabled type="text" id="pc-coins" name="pc-coins" required maxLength="255" placeholder="Coins" value={pcCurrencies?.coins / 1000} className='form-control' />
                        <div className="input-group-append">
                            <span className="input-group-text">K</span>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 mb-3">
                    <label style={{ color: 'var(--primary-color3)' }} htmlFor="pc-amount">Amount</label>
                    <div className="input-group">
                        <input style={{ backgroundColor: 'var(--primary-color10) !important' }} disabled type="number" id="pc-amount" name="pc-amount" required placeholder="Amount" value={pcCurrencies?.amount} className='form-control' />
                        <div className="input-group-append">
                            <span className="input-group-text">USD</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-12 d-flex justify-content-end'>
                    <Button type='primary' onClick={() => handleUpdate(pcCurrencies)} >
                        Update
                    </Button>
                </div>
            </div>

          
            <UpdateCurrencies isOpen={isOpen} onClose={() => setIsOpen(false)} currencie={currencie} onUpdate={onUpdate} />
            <ToastContainer draggable />

        </>
    );
};

export default Currencies;